export async function CallAPI(url, options, credential = true) {
  let headerOptions =
    options.headers === undefined
      ? { "Content-Type": "application/json" }
      : options.headers;

  if (credential) {
    const session = getSessionToken();
    if (session !== undefined) {
      headerOptions = {
        ...headerOptions,
        Authorization: `Bearer ${session}`,
      };
    }
    options.headers = new Headers(headerOptions);
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 5000); // 5s
  options.signal = controller.signal;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${url}`,
      options
    );
    clearTimeout(timeoutId);
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = "/";
      }
      throw await response.json();
    }
    return response.json();
  } catch (error) {
    clearTimeout(timeoutId);
     // ✅ اضافه شد: هندل وقتی بک‌اند اصلاً جوابگو نیست / اینترنت قطع / CORS / DNS / ...
    if (error?.name === "AbortError") {
      throw { error: "سرور پاسخ نداد (timeout). لطفاً دوباره تلاش کنید." };
    }

    // fetch وقتی network error می‌خوره معمولاً TypeError می‌ده
    if (error instanceof TypeError) {
      throw { error: "ارتباط با سرور برقرار نشد. اینترنت/سرور را بررسی کنید." };
    }
    throw error;
  }
}

export function getSessionToken() {
  const token = localStorage.getItem("token");
  if (token === null || token === undefined) {
    return undefined;
  }
  try {
    return token;
  } catch (error) {
    return undefined;
  }
}

export function getSessionUsername() {
  const fullname = localStorage.getItem("fullname");
  if (fullname === null || fullname === undefined) {
    return undefined;
  }
  try {
    return fullname;
  } catch (error) {
    return undefined;
  }
}
